//TODO: if changes are stable, remove commented code

function setSingleTranslationObj(translationData, tMap, trKey) {
    const translationObj = {};
    const singleTranslationData = translationData.get(trKey);
    if (!tMap.has(trKey) && singleTranslationData) {
        translationObj["@"] = { key: trKey };
        translationObj["l"] = getLanguageObj(singleTranslationData.lng);
        tMap.set(trKey, translationObj);
    }
}

function getLanguageObj(list) {
    const lngXmlObjList = [];

    if (list) {
        list.forEach((lng) => {
            const lngXmlObj = {};

            lngXmlObj["@"] = { id: lng.id };
            lngXmlObj["#"] = lng.text;
            lngXmlObjList.push(lngXmlObj);
        });
    }
    return lngXmlObjList
}


function arrayToMapTranslations(array) {
    const map = new Map();
    array.forEach(el => {
        map.set(el.key, el);
    })
    return map;
}

const getTranslationKey = recommendedTypeObject => recommendedTypeObject.templateTranslationKey || recommendedTypeObject.translationKey;

function getTranslations() {
    const translationData = arrayToMapTranslations(require('../../assets/translations.json'));

    //** the code below should be in separate function in future - TODO when new dynamic translation occurs
    const defSites = require('../../assets/defSites.json');
    const allRecommendedTypes = require('../../assets/liquidSettingsTypes/recommendedType.json');
    const objectsToDynamicGeneratedTranslations = [];
    for (const site of defSites) {
        if ((localStorage.getItem('onePageShop') === "true" && site.ignoreOPS) || (localStorage.getItem('onePageShop') === "false" && site.ignoreTPZ)) {
            continue;
        }
        if (site.listName) {
            const list = this.state[site.listName];
            list.forEach((element) => {
                if (element.type === 'newsSection') {
                    const recommendedType = JSON.parse(element.config).Type;
                    const recommendedTypeObject = allRecommendedTypes.find(type => type.value === recommendedType);
                    objectsToDynamicGeneratedTranslations.push({
                        recommendedName: element.name,
                        translationKey: getTranslationKey(recommendedTypeObject),
                    });
                }
            });
        }
    }

    objectsToDynamicGeneratedTranslations.forEach((element) => {
        const recommendedTranslationName = element.recommendedName.replaceAll('-', '_'); //prevent pa validation bug
        const originalTranslation = translationData.get(element.translationKey);
        const dynamicGeneratedTranslation = JSON.parse(JSON.stringify(originalTranslation)); //deepCopy
        dynamicGeneratedTranslation.key = recommendedTranslationName;
        translationData.set(recommendedTranslationName, dynamicGeneratedTranslation)
    });
    //**

    const translationObj = {};
    const tMap = new Map();

    //TODO fix performance a bit
    translationData.forEach((_value, key) => {
        setSingleTranslationObj(translationData, tMap, key);
    });

    translationObj["t"] = Array.from(tMap.values());
    return translationObj;
}

export default getTranslations;